import { Form } from '@template/components';
import { IFormProps } from '@template/components/Form';
import { useEffect, useState } from 'react';
import * as S from './styles.ts';
import { useTypedDispatch, useTypedSelector } from '@/redux/helpers/hooks.ts';
import useMounted from '@/lib/helpers/hooks/useMounted.ts';
import { getTldPrices } from '@/redux/slices/store/thunks/getTldPrices.ts';

const Inputs = () => {
  const dispatch = useTypedDispatch();
  const loaded = useTypedSelector((state) => state.store.tlds.prices.loaded);

  const mounted = useMounted();

  const [formValues, setFormValues] = useState<{
    filter: string;
    action: any;
    category: any;
    period: number;
  }>({
    filter: '',
    action: 'create',
    category: 'popular',
    period: 1,
  });

  const inputs: IFormProps['inputs'] = [
    {
      label: 'Domain Extension',
      placeholder: 'com, net, org...',
      type: 'text',
      name: 'filter',
      span: 3,
    },
    {
      label: 'Domain Category',
      placeholder: 'Select category',
      type: 'select',
      name: 'category',
      options: [
        {
          label: 'All',
          key: 'all',
        },
        {
          label: 'Popular',
          key: 'popular',
        },
        {
          label: 'Personal',
          key: 'personal',
        },
        {
          label: 'Business',
          key: 'business',
        },
        {
          label: 'Geographic',
          key: 'geographic',
        },
      ],
      span: 3,
    },
    {
      label: 'Domain Purchase Type',
      placeholder: 'Select purchase type',
      type: 'select',
      name: 'action',
      options: [
        {
          label: 'Registration',
          key: 'create',
        },
        {
          label: 'Transfer',
          key: 'transfer',
        },
        {
          label: 'Renewal',
          key: 'renew',
        },
      ],
      span: 3,
    },
    {
      label: 'Registration Period',
      placeholder: 'Select registration period',
      disabled: formValues.action === 'transfer',
      type: 'select',
      name: 'period',
      selected: formValues.action === 'transfer' ? 1 : undefined,
      options: [
        {
          label: '1 Year',
          key: 1,
        },
        {
          label: '2 Years',
          key: 2,
        },
        {
          label: '3 Years',
          key: 3,
        },
        {
          label: '4 Years',
          key: 4,
        },
        {
          label: '5 Years',
          key: 5,
        },
        {
          label: '6 Years',
          key: 6,
        },
        {
          label: '7 Years',
          key: 7,
        },
        {
          label: '8 Years',
          key: 8,
        },
        {
          label: '9 Years',
          key: 9,
        },
        {
          label: '10 Years',
          key: 10,
        },
      ],
      span: 3,
    },
  ];

  const onSubmit = () => {
    dispatch(
      getTldPrices({
        ...formValues,
        filter: formValues.filter.replace('.', ''),
      })
    );
  };

  useEffect(() => {
    if (mounted) return;
    onSubmit();
  }, [mounted]);

  return (
    <S.Form>
      <Form
        inputs={inputs}
        value={formValues}
        onChange={setFormValues}
        submit={{
          onSubmit,
          text: 'Filter',
          fullWidth: false,
          size: 'md',
          style: {
            marginLeft: 'auto',
          },
          disabled: !loaded,
        }}
      />
    </S.Form>
  );
};

export default Inputs;
